import { computed } from 'vue'

export function usePaginationComputed(props) {
  const totalPages = computed(() => Math.ceil(props.total / props.itemsPerPage))

  // Grande page servie par tranches : `loadedCount` dit ce qui est réellement à
  // l'écran, sinon le compteur annoncerait la page entière dès la 1re tranche.
  const isProgressive = computed(() => props.loadedCount !== null && props.loadedCount !== undefined)

  const pageStart = computed(() => (props.currentPage - 1) * props.itemsPerPage)

  const startItem = computed(() => {
    if (props.total === 0) return 0
    // Ensure startItem doesn't exceed total (can happen if currentPage is too high)
    return Math.min(pageStart.value + 1, props.total)
  })

  const endItem = computed(() => {
    if (props.total === 0) return 0
    const end = pageStart.value + (isProgressive.value ? props.loadedCount : props.itemsPerPage)
    return Math.min(end, props.total)
  })

  const visiblePages = computed(() => {
    const pages = []
    const start = Math.max(1, props.currentPage - props.maxVisiblePages)
    const end = Math.min(totalPages.value, props.currentPage + props.maxVisiblePages)
    
    for (let i = start; i <= end; i++) {
      pages.push(i)
    }
    
    return pages
  })

  const showFirstPage = computed(() => {
    return visiblePages.value[0] > 1
  })

  const showFirstEllipsis = computed(() => {
    return visiblePages.value[0] > 2
  })

  const showLastPage = computed(() => {
    return visiblePages.value[visiblePages.value.length - 1] < totalPages.value
  })

  const showLastEllipsis = computed(() => {
    const lastVisible = visiblePages.value[visiblePages.value.length - 1]
    return lastVisible < totalPages.value - 1
  })

  return {
    totalPages,
    startItem,
    endItem,
    visiblePages,
    showFirstPage,
    showFirstEllipsis,
    showLastPage,
    showLastEllipsis
  }
}
